/** Pet Friends 스마트 코딩 미니카 — 제품 디자인 케이스 데이터 */

export const PET_FRIENDS_SLUG = 'pet-friends'

export const PET_FRIENDS_SHEET_IMG = '/assets/img/design/pet-friends-sheet.png'
export const PET_FRIENDS_PROCESS_IMG = '/assets/img/design/pet-friends-process.png'
export const PET_FRIENDS_CONCEPT_MOCKUP_IMG =
    '/assets/img/design/pet-friends-concept-mockup.png'
export const PET_FRIENDS_LIFESTYLE_IMG = '/assets/img/design/pet-friends-lifestyle.png'

export const petFriendsPortfolioCard = {
    slug: PET_FRIENDS_SLUG,
    title: 'Pet Friends',
    excerpt:
        '스마트 코딩 미니카 — 동물 캐릭터 자율주행 로봇으로 아이들이 코딩·놀이를 통해 차량을 제어하는 교육용 장치입니다.',
    image: PET_FRIENDS_LIFESTYLE_IMG,
    imageAlt: 'Pet Friends 스마트 코딩 미니카 — 4색 동물 캐릭터 스튜디오 렌더',
    year: '2023',
    tags: ['교육용 로봇', '코딩', '캐릭터 디자인'],
}

const petFriendsShowcases = [
    {
        id: 'pet-friends-process',
        kicker: 'Design process',
        title: '컨셉 · 타겟 · 포지셔닝',
        tagline: '스마트 코딩 미니카',
        image: PET_FRIENDS_PROCESS_IMG,
        imageAlt:
            'Pet Friends 디자인 프로세스 — 개발 컨셉, 디자인 포지셔닝, 초등·중학생 타겟, 동물 캐릭터 영감',
        description: [
            '기존 DIY 로봇은 내부 부품이 노출되어 미관이 떨어지고 거부감을 줄 수 있어, 내부 고정 부품 경계를 고려한 외장 커버 디자인을 목표로 했습니다.',
            '남성적·화려한 기존 제품군 대비 심플하고 친근한(여성성·중성) 포지션을 개발 목표로 설정했습니다. 초등~중학생 타깃에 맞춰 성별에 구애받지 않는 동물 캐릭터를 적용했습니다.',
        ],
        features: [
            {
                title: '외장 커버 콘셉트',
                text: '노출된 회로·배선을 가리고 교육용 제품다운 완성도를 높였습니다.',
            },
            {
                title: '디자인 포지셔닝',
                text: '심플·친근 영역으로 이동해 남성 중심 시장과 차별화했습니다.',
            },
            {
                title: '타깃',
                text: '초등학생부터 중학생까지, 시각적으로 매력적인 학습 도구를 전제했습니다.',
            },
            {
                title: '동물 캐릭터',
                text: '오리·여우·고양이·강아지 등 친숙한 동물 모티브로 친근감을 확보했습니다.',
            },
        ],
    },
    {
        id: 'pet-friends-concept-mockup',
        kicker: 'Concept · Mockup',
        title: '디자인 컨셉 · 목업',
        tagline: 'Pet Friends',
        image: PET_FRIENDS_CONCEPT_MOCKUP_IMG,
        imageAlt:
            'Pet Friends — 곰·고양이 등 3D 컨셉, 컬러웨이·후면·내부 2T·볼트 리브, 트랙 목업 사진',
        description: [
            '동물 바디 형태를 그대로 적용하고 머리 부분에 다양한 동물 캐릭터를 얹어 디자인 라인을 구축했습니다. 화이트·브라운·그레이·옐로우 4컬러와 상단 센서·전면 LED 눈이 공통 UX입니다.',
            '목업 제작을 위해 볼트 체결부 리브살·2T 두께를 반영했고, 트랙 위 실물 목업으로 주행·코딩 학습 시나리오를 검증했습니다.',
        ],
        features: [
            {
                title: '모듈형 캐릭터 헤드',
                text: '공통 바디에 동물별 헤드·귀·코 형상을 교체·확장할 수 있게 설계했습니다.',
            },
            {
                title: '센서·LED',
                text: '상단 블랙 실린더 센서와 전면 원형 LED로 자율주행·피드백을 표현했습니다.',
            },
            {
                title: '양산 구조',
                text: '볼트 체결 리브·2T 두께 등 목업 단계에서 조립·내구를 고려했습니다.',
            },
            {
                title: '트랙 목업',
                text: '블랙 라인 트랙 위 주행 테스트로 교육 현장 사용성을 확인했습니다.',
            },
        ],
    },
    {
        id: 'pet-friends-lifestyle',
        kicker: 'Studio',
        title: 'Pet Friends',
        tagline: '4 animal characters',
        image: PET_FRIENDS_LIFESTYLE_IMG,
        imageAlt:
            'Pet Friends 미니카 4종 — 옐로·브라운·그레이·화이트, 파스텔 스튜디오 연출',
        description: [
            '라이트 핑크 바닥·파스텔 기하 소품·플로팅 스피어로 어린이·교육 브랜드 톤을 연출했습니다. 네 대를 나란히 배치해 제품군·컬러 선택을 한눈에 보여 줍니다.',
            '부드러운 스튜디오 라이팅과 반사로 매트 CMF·둥근 실루엣의 장난감 같은 인상을 강조했습니다.',
        ],
        features: [
            {
                title: '4컬러 라인업',
                text: '옐로(새)·브라운(곰)·그레이(고양이)·화이트(강아지) 캐릭터를 병렬 제시합니다.',
            },
            {
                title: '파스텔 CMF',
                text: '핑크·민트·피치 배경과 조화되는 파스텔·매트 마감입니다.',
            },
            {
                title: '교육·놀이 톤',
                text: '코딩 학습이 부담스럽지 않은 장난감·친구 이미지를 목표로 했습니다.',
            },
            {
                title: '마케팅 컷',
                text: '패키지·상세·SNS에 활용 가능한 히어로급 스튜디오 렌더입니다.',
            },
        ],
    },
]

const petFriendsProcessPhases = [
    {
        id: 'concept',
        title: '콘셉트 & 문제 정의',
        lede: '노출 부품을 가리는 외장과 친근한 동물 캐릭터가 핵심입니다.',
        body: '기존 코딩 로봇의 DIY 느낌을 줄이고, 내부 고정된 부품 경계 안에서 외형을 도출했습니다. 교육용이므로 모든 성별·연령이 편하게 다룰 수 있는 친숙한 외관을 목표로 했습니다.',
    },
    {
        id: 'positioning',
        title: '포지셔닝 & 타깃',
        lede: '심플·친근 영역의 스마트 코딩 미니카로 포지셔닝했습니다.',
        body: '초등~중학생이 코딩을 쉽고 재미있게 배우는 자율주행 미니카입니다. 동물 캐릭터를 통해 연습·놀이·제어 학습을 한 제품에서 이어갑니다.',
    },
    {
        id: 'mockup',
        title: '3D · 목업',
        lede: '동물 바디·헤드 모듈과 트랙 목업으로 형태·조립을 검증했습니다.',
        body: '160×126×130(mm), ABS 기준으로 볼륨·바퀴·센서 배치를 정리했습니다. 리브·2T 두께를 반영한 목업으로 실제 주행·코딩 교육 환경을 테스트했습니다.',
    },
    {
        id: 'viz',
        title: '시각화',
        lede: 'Rhinoceros·KeyShot·Photoshop으로 시트·프로세스·스튜디오 렌더를 제작했습니다.',
        body: '4색 라인업 시트, 디자인 프로세스 보드, 컨셉·목업 보드, 파스텔 스튜디오 컷으로 갤러리·상세·마케팅 산출물을 구성했습니다.',
    },
]

export const petFriendsDesignCase = {
    pageTitle: 'Pet Friends 스마트 코딩 미니카',
    masthead: 'Pet Friends',
    mastheadSub: 'Smart coding minicar',
    showcaseSectionTitle: '제품 특징 · 디자인 프로세스',
    metaDescription:
        'Pet Friends 스마트 코딩 미니카 — 동물 캐릭터 자율주행 교육 로봇, 코딩·목업, Rhino·KeyShot 제품 디자인 사례입니다.',
    meta: {
        client: 'Pet Friends',
        year: '2023',
        scope: '제품 디자인 · Rhinoceros · KeyShot · Photoshop',
        size: '160 × 126 × 130 (mm)',
        material: 'ABS',
    },
    intro: {
        lead: '아이들이 코딩을 쉽고 재미있게 배울 수 있는 자율주행 코딩 미니카입니다.',
        left: '친화적인 동물 캐릭터를 통해 코딩을 연습하고 놀이하며, 코딩으로 자동차를 제어하는 방법을 배우는 교육용 장치입니다. 옐로·브라운·그레이·화이트 네 가지 캐릭터 라인을 제시했습니다.',
        right: '제품 시트로 라인업·스펙을, 프로세스 보드로 컨셉·포지셔닝·타깃을, 컨셉·목업 보드로 3D·실물 검증을, 스튜디오 컷으로 브랜드 톤을 전달합니다.',
    },
    hero: {
        src: PET_FRIENDS_SHEET_IMG,
        alt: 'Pet Friends 스마트 코딩 미니카 제품 시트 — 4색 동물 캐릭터 3D 렌더',
    },
    productShowcases: petFriendsShowcases,
    processPhases: petFriendsProcessPhases,
    deliverables: [
        '외장 커버·동물 캐릭터 콘셉트·포지셔닝 정리',
        'Rhinoceros 3D 모델·컬러웨이·분해 렌더',
        '볼트 리브·2T 두께 등 목업 구조 시안',
        '트랙 주행 물리 목업 검증',
        '제품 스펙 시트(160×126×130 mm · ABS · 2023)',
        'Photoshop 프로세스·스튜디오 컷',
    ],
    outro: [
        '교육 로봇도 캐릭터 CMF와 완성된 외장으로 학습 진입 장벽을 낮출 수 있습니다.',
        'Pet Friends는 코딩 교육·자율주행·동물 IP를 한 플랫폼에 담은 제품 디자인 사례입니다.',
        '코담디자인은 교육·키즈 테크 제품의 형태·캐릭터·렌더 시각화를 지원합니다.',
    ],
}
